const getBanksFromAggregatorData = (immAggregatorData) => {
    if (!immAggregatorData || !immAggregatorData.getIn(['data', 'banks'])) return []
    return Object.values(immAggregatorData.getIn(['data', 'banks']).toJS())
}

export default getBanksFromAggregatorData;
